import { useMemo } from 'react'
import { useAuth } from 'context/user'
import { DEFAULT_SAMPLE_SEED } from 'lib/overlaySamples'
import { mintPreviewSeam, onOverlayPagePath, OverlayPreviewSeam, PreviewMode } from 'components/overlayPreview/previewSeam'
import type { ChatPreviewFeed, WallPreviewFeed } from 'components/overlayPreview/previewFeeds'

export const useOverlayPreviewSeam = ({
  mode,
  chatFeed = null,
  wallFeed = null,
  seed = DEFAULT_SAMPLE_SEED
}: {
  mode: PreviewMode
  chatFeed?: ChatPreviewFeed | null
  wallFeed?: WallPreviewFeed | null
  seed?: number
}): OverlayPreviewSeam | null => {
  const { auth0Token } = useAuth()
  const signedIn = typeof auth0Token === 'string' && auth0Token !== ''
  const onOverlayPath = typeof globalThis.location === 'undefined' ||
    onOverlayPagePath(globalThis.location.pathname)
  return useMemo(
    () => (signedIn && !onOverlayPath ? mintPreviewSeam({ mode, chatFeed, wallFeed, seed }) : null),
    [signedIn, onOverlayPath, mode, chatFeed, wallFeed, seed]
  )
}
